import React, { FC } from 'react';
import { MediaType } from '../../../../../constants/MediaType';
import { getFileMediaType } from '../../../../../utils/media-manager-sdk/items';
import { MusicControls } from '../../../Generic/Controls/MusicControls';
import { VideoControls } from '../../../Generic/Controls/VideoControls';
import { IOuter } from './GalleryFileControls.types';

const getControlsComponent = (mediaType) => {
  switch (mediaType) {
    case MediaType.SecureMusic:
    case MediaType.Music:
      return MusicControls;

    case MediaType.SecureVideo:
    case MediaType.Video:
      return VideoControls;

    default:
      return () => null;
  }
};

export const GalleryFileControls: FC<IOuter> = (props) => {
  const GalleryFileControlsComponent = getControlsComponent(getFileMediaType(props.file));

  return <GalleryFileControlsComponent {...props} />;
};
